import { InventoryDataExtractor } from '../../../../common/inventory/extractors/InventoryDataExtractor';
import { InventoryMapper } from '../../../../common/inventory/mappers/InventoryMapper';
import { CsvPayload } from '../models/CsvPayload';

export class CsvInventoryMapper {
  private readonly inventoryMapper = new InventoryMapper();
  private readonly inventoryExtractor = new InventoryDataExtractor();

  mapGQLModel(data: any): CsvPayload {
    const inventoryHeaders = ['Type', 'Value', 'Instances', 'Percentage'];

    const inventoryRecap = this.inventoryMapper.mapGQLModel(data);
    if (!inventoryRecap || inventoryRecap.isEmpty()) {
      return new CsvPayload(inventoryHeaders, []);
    }

    const { keyStores, hashFunctions, mac, symmetricAlgorithms, asymmetricAlgorithms, operations, keys } =
      this.inventoryExtractor.extractInventoryElements(inventoryRecap);

    const inventory: string[][] = [];

    for (const item of [...(keys ?? []), operations, symmetricAlgorithms, asymmetricAlgorithms, keyStores, hashFunctions, mac]) {
      if (!item || !item.getName() || item.getLines().length === 0) {
        continue;
      }
      const rows: string[][] = [];
      for (const line of item.getLines()) {
        rows.push([item.getName(), line.getName(), line.getCount().toString(), line.getPercentage()?.toString() ?? '']);
      }
      inventory.push(...rows);
    }

    return new CsvPayload(inventoryHeaders, inventory);
  }
}
